@if (parentForm) {
  <form [formGroup]="parentForm">
      <div class="row">
          <div class="containerTwo">
              <div class="oneCell">
                  <prism-ui-form-field
                      [isValid]="isMonthFieldValid()"
                      [keyId]="monthName"
                  >
                      <span slot="label">{{selectedTextMonth}}</span>
      
                      <!-- Required errors: only show on submit (when touched) -->
                      <!-- For lastdateOfVisit, check individual month control; otherwise check combined questionNumber control -->
                      @if (lastdateOfVisit && parentForm.get(monthName)?.hasError('required') && parentForm.get(monthName)?.touched) {
                        <span slot="error">{{ requiredElement?.error }}</span>
                      } 
                      @if (!lastdateOfVisit && (parentForm.get(questionNumber)?.hasError('required') || parentForm.get(questionNumber)?.hasError('monthRequired')) && parentForm.get(questionNumber)?.touched){
                        <span slot="error">{{ requiredElement?.error }}</span>
                      }
                     
                      <!-- Date errors: show immediately when both fields filled (no touched check) -->
                      @if (parentForm.get(questionNumber)?.hasError('futureDated') && !isPregnancyQuestion) {
                        <span slot="error">{{ futureDatedElement?.error }}</span>
                      } 
                      @if (parentForm.get(questionNumber)?.hasError('futureDated') && isPregnancyQuestion) {
                        <span slot="error">{{ futureDatedPregnancyElement?.error }}</span>
                      }
                      
                      @if (parentForm.get(questionNumber)?.hasError('backDatedPregnancy') && isPregnancyQuestion) {
                        <span slot="error">{{ backDatedPregnancyElement?.error }}</span>
                      }
                      
                      @if (parentForm.get(questionNumber)?.hasError('backDatedResolution') && isResolutionDateQuestion) {
                        <span slot="error">{{ backDatedResolutionElement?.error }}</span>
                      }
                      
      
                      <prism-ui-select
                          slot="input"
                          [keyId]="monthName"
                          id="{{monthName}}"
                          [options]="months"
                          [selectedValue]="getFieldLabel(parentForm.get(monthName)?.value)"
                          ngDefaultControl
                          [formGroup]="parentForm"
                          formControlName="{{monthName}}"
                          [isValid]="isMonthFieldValid()"
                          (selectEvent)="handleOptionSelectedMonth($event, monthName)"
                          [hasPlaceholder]="true"
                      >
                      </prism-ui-select>
                  </prism-ui-form-field>
              </div>
              @if (lastdateOfVisit) {
              <div class="oneCell ">
                  <prism-ui-form-field
                      [isValid]="isYearFieldValid()"
                      [keyId]="yearName"
                  >
                      
                  <span slot="label" class="form22117opacity">{{selectedTextYear}}</span>
                      <!-- Show required error when both fields empty or only year empty -->
                      <!-- For lastdateOfVisit, check individual year control; otherwise check combined questionNumber control -->
                      @if (lastdateOfVisit && parentForm.get(yearName)?.hasError('required') && parentForm.get(yearName)?.touched) {
                        <span slot="error">{{ requiredElement?.error }}</span>
                      } 
                      @if (!lastdateOfVisit && (parentForm.get(questionNumber)?.hasError('required') || parentForm.get(questionNumber)?.hasError('yearRequired')) && parentForm.get(questionNumber)?.touched) {
                        <span slot="error">{{ requiredElement?.error }}</span>
                      }
                      
                      <prism-ui-select
                          slot="input"
                          [keyId]="yearName"
                          id="{{yearName}}"
                          [options]="years"
                          [selectedValue]="getYearFieldLabel(parentForm.get(yearName)?.value)"
                          ngDefaultControl
                          [formGroup]="parentForm"
                          formControlName="{{yearName}}"
                          [isValid]="isYearFieldValid()"
                          (selectEvent)="handleOptionSelectedYear($event, yearName)"
                          [hasPlaceholder]="true"
                      >
                      </prism-ui-select>
                  </prism-ui-form-field>
              </div>
              }
              @if (!isPregnancyQuestion && !lastdateOfVisit) {
                <div>
                    <div class="oneCell">
                        <prism-ui-form-field
                            [isValid]="isYearFieldValid()"
                            [keyId]="yearName"
                        >
                            <span slot="label">{{selectedTextYear}}</span>
            
                            <!-- Show required error when both fields empty or only year empty -->
                             @if ((parentForm.get(questionNumber)?.hasError('required') || parentForm.get(questionNumber)?.hasError('yearRequired')) && parentForm.get(questionNumber)?.touched) {
                              <span slot="error">{{ requiredElement?.error }}</span>
                             }
                            
                            <prism-ui-select
                                slot="input"
                                [keyId]="yearName"
                                id="{{yearName}}"
                                [options]="years"
                                [selectedValue]="getYearFieldLabel(parentForm.get(yearName)?.value)"
                                ngDefaultControl
                                [formGroup]="parentForm"
                                formControlName="{{yearName}}"
                                [isValid]="isYearFieldValid()"
                                (selectEvent)="handleOptionSelectedYear($event, yearName)"
                                [hasPlaceholder]="true"
                            >
                            </prism-ui-select>
                        </prism-ui-form-field>
                    </div>
                </div>
              }
              @if (isPregnancyQuestion) {
              <div>
                  <div class="oneCell">
                      <prism-ui-form-field
                          [isValid]="isYearFieldValid()"
                          [keyId]="yearName"
                      >
                          <span slot="label">{{selectedTextYear}}</span>
          
                          <!-- Show required error when both fields empty or only year empty -->
                           @if ((parentForm.get(questionNumber)?.hasError('required') || parentForm.get(questionNumber)?.hasError('yearRequired')) && parentForm.get(questionNumber)?.touched){
                            <span slot="error">{{ requiredElement?.error }}</span>
                           }
                          
                          <prism-ui-select
                              slot="input"
                              [keyId]="yearName"
                              id="{{yearName}}"
                              [options]="pregnancyYears"
                              [selectedValue]="getPregnancyYearsFieldLabel(parentForm.get(yearName)?.value)"
                              ngDefaultControl
                              [formGroup]="parentForm"
                              formControlName="{{yearName}}"
                              [isValid]="isYearFieldValid()"
                              (selectEvent)="handleOptionSelectedYear($event, yearName)"
                              [hasPlaceholder]="true"
                          >
                          </prism-ui-select>
                      </prism-ui-form-field>
                  </div>
              </div>
              }
          </div>
      </div>
  </form>
}